import Divider from "../../componets/Divider";

export default function Section3() {
  return (
    <div className="Section5">
      <div className="w-full section5-container px-[20px] md:px-[30px] md:pt-[2%] my-[4%] md:my-0 block md:flex md:justify-evenly md:items-start">
        <div className="md:w-[36%] w-full mb-5 md:mb-0">
          <h2 className="md:text-[34px] text-[#DA2128] font-bold text-[24px] leading-[32px] md:leading-[41px] my-[0.67em] pb-[2%]">
            Benefits of IT Project Outsourcing
          </h2>

          <p className="text-base leading-[20px] pb-[1%] text-[#373737] mb-5 font-open">
            Uncover the world of technical expertise, right at your
            organisation's doorstep.
          </p>

          <ul className="w-full text-[12px] md:text-[14px] font-[500] pb-[10px] font-open text-[#535353]">
            <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
              World-class IT professionals
            </li>
            <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
              Highly economical
            </li>
            <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
              Unlimited operational capacity
            </li>
            <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
              Consistent communication
            </li>
            <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
              Flexible team upgrade
            </li>
            <li className="py-[3px] before:content-['\2713'] before:text-[#DA2128] before:font-[600] before:pr-[5px] before:text-base">
              Automate everyday tasks.
            </li>
          </ul>
        </div>

        <div className="img-container">
          <img
            className="block object-cover w-full"
            src="/assets/computer-project-out.png"
          ></img>
        </div>
      </div>

      <Divider />
    </div>
  );
}
